import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedItem } from '@reducers/machines';
import { Machine } from '@interfaces/machines';
import { Text, View } from 'react-native';
import { font } from '@styles/fonts';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { scale } from '@components/frame';
import { useManageBatchBlockHeader } from '@v2/pages/machines/modules/now/components/Overview/components/BatchBlock/hooks/useManageBatchBlockHeader';
import { ContainerStyle } from '@interfaces/base';
import i18n from 'i18n-js';
import { BULLET } from '@v2/pages/common/constants/base.constants';

interface BatchBlockHeaderProps extends ContainerStyle {
  C: ColorFunction;
}

const BatchBlockHeader: FC<BatchBlockHeaderProps> = ({ C, containerStyle }) => {
  const machine: Machine = useSelector(selectSelectedItem);

  const { batchStatusBadgeConfig, batchNumber } = useManageBatchBlockHeader();

  const ncFileName = machine?.machineStatus?.ncFile;

  return (
    <View
      style={[
        { width: '100%', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', gap: scale(8), flex: 1 },
        containerStyle,
      ]}
    >
      <View style={{ flex: 1, justifyContent: 'flex-start', transform: [{ translateY: scale(-3) }] }}>
        <Text numberOfLines={1} style={[font.Headline, { color: C('Label/Light/Primary') }]}>
          {ncFileName}
        </Text>
        <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>
          {i18n.t('BATCH')} {batchNumber}
        </Text>
      </View>
      {batchStatusBadgeConfig && (
        <View
          style={{
            alignSelf: 'flex-start',
            paddingVertical: scale(2.5),
            paddingHorizontal: scale(7),
            height: scale(23),
            borderRadius: scale(20),
            backgroundColor: C(batchStatusBadgeConfig.bg),
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: scale(4),
          }}
        >
          {batchStatusBadgeConfig.withDot && <Text style={[font.Footnote, { color: C('System/Light/Blue') }]}>{BULLET}</Text>}
          <Text style={[font.Footnote, { color: C(batchStatusBadgeConfig.color) }]}>{i18n.t(batchStatusBadgeConfig.text)}</Text>
        </View>
      )}
    </View>
  );
};

export default ColorWrapper(BatchBlockHeader);
